/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface ErrorDef { 
    args?: Array<string>;
    comment?: string;
    defaultErrorMessage?: string;
    deprecated?: boolean;
    detailedErrorMessage?: string;
    errorCode?: string;
}

